import { FormFieldComponent } from "../formFieldComponent";
import { Subject } from "rxjs";
import { Form } from "../form";
import { IMessagingService } from "../../services";
import { ResponseDto } from "@se/platform/forms/dtos/out/responses/responseDto";

class DropdownComponent extends FormFieldComponent {
    private wrapperEl: HTMLDivElement;
    private buttonEl: HTMLElement;
    private optionEls: HTMLLIElement[];
    private focusedOptionIndex$ = new Subject<number>();
    private focusedOptionIndex: number = -1;
    private onDocKeydownBound: (e: KeyboardEvent) => void;
    private placeholder: string;
    private type: string;
    private selectEl: HTMLSelectElement;

    constructor(protected fieldEl: HTMLElement, messagingService: IMessagingService, protected form: Form) {
        super(fieldEl, messagingService, form);

        this.type = fieldEl.getAttribute("data-type");
        if (this.type != null) {
            this.selectEl = fieldEl.querySelector<HTMLSelectElement>("select");
            return;
        }
        this.placeholder = fieldEl.getAttribute("data-placeholder");
        this.wrapperEl = fieldEl.querySelector(".form-field__dropdown-wrapper");
        this.buttonEl = fieldEl.querySelector(".js-form-field-dropdown-button");
        this.optionEls = Array.from(fieldEl.querySelectorAll(".js-form-field-dropdown-option"));

        this.focusedOptionIndex$.subscribe((index) => {
            this.focusedOptionIndex = index;
            this.optionEls.forEach((el, i) => {
                if (index === i) {
                    el.focus();
                    el.setAttribute("aria-selected", "true")
                } else {
                    el.setAttribute("aria-selected", "false");
                }
            });
        });

        this.onDocKeydownBound = this.onDocKeydown.bind(this);

        this.buttonEl.addEventListener("click", (e: Event) => {
            e.preventDefault();
            this.expand();
        });

        this.buttonEl.addEventListener("focus", () => {
            this.expand();
            document.addEventListener("keydown", this.onDocKeydownBound, true);
        });

        this.wrapperEl.addEventListener("focusout", (e) => {
            if (e.relatedTarget && this.wrapperEl.contains(e.relatedTarget as HTMLElement)) return;
            this.onFocusOut();
        });

        this.optionEls.forEach((option, i) => {
            option.addEventListener("click", () => {
                this.selectOption(i);
            });
        });
    }

    public getValue(): ResponseDto {
        let responseDto = super.getValue();
        if (this.type != null) {
            responseDto.value = this.selectEl.options[this.selectEl.selectedIndex].value;
        }
        return responseDto;
    }
    // update the value of this field in the DOM.
    protected setDisplayValue(value: any) {

        if(value) {
            const selectedOptionEl = this.optionEls.find((el) => el.getAttribute("data-value") === value);

            if (typeof selectedOptionEl !== "undefined") {
                selectedOptionEl.setAttribute("aria-selected", "true");
                this.buttonEl.textContent = selectedOptionEl.textContent;
            }
            else if (this.placeholder?.length > 0) {
                this.buttonEl.textContent = this.placeholder;
            }
            else if (typeof this.optionEls[0] !== "undefined") {
                this.buttonEl.textContent = this.optionEls[0].textContent;
            }
            else {
                this.buttonEl.textContent = "";
            }
        }
    }

    private onFocusOut() {
        this.focusedOptionIndex = -1;
        this.buttonEl.setAttribute("aria-expanded", "false");
        this.containerEl.classList.remove("form-field--dropdown--expanded");
        document.removeEventListener("keydown", this.onDocKeydownBound, true);
    }

    private selectOption(index: number) {
        if (index > -1) {
            const selectedValue = this.optionEls[index].getAttribute("data-value");
            this.setResponseValue(selectedValue);

            this.optionEls.forEach((el, i) => {
                if (index === i) {
                    el.setAttribute("aria-selected", "true");
                } else {
                    el.setAttribute("aria-selected", "false");
                }
            });
            this.buttonEl.focus();
            setTimeout(() => {
                this.collapse();
            }, 0);
        }
    }

    private expand() {
        this.containerEl.classList.add("form-field--dropdown--expanded");
        this.buttonEl.setAttribute("aria-expanded", "true");
    }

    private collapse() {
        this.containerEl.classList.remove("form-field--dropdown--expanded");
        this.buttonEl.setAttribute("aria-expanded", "false");
    }

    private onDocKeydown(e: KeyboardEvent) {
        if (e.code === "ArrowDown") {
            e.preventDefault();
            // Arrow down
            if (this.focusedOptionIndex === -1) {
                this.expand();
            }
            if (this.focusedOptionIndex < this.optionEls.length - 1) {
                this.focusedOptionIndex$.next(this.focusedOptionIndex + 1);
            }
        } else if (e.code === "ArrowUp") {
            e.preventDefault();
            if (this.focusedOptionIndex === 0) {
                this.focusedOptionIndex$.next(this.focusedOptionIndex - 1);
                this.collapse();
                this.buttonEl.focus();
            } else if (this.focusedOptionIndex > 0) {
                this.focusedOptionIndex$.next(this.focusedOptionIndex - 1);
            }
        } else if (e.code === "Escape") {
            this.focusedOptionIndex$.next(-1);
            this.collapse();
            this.buttonEl.focus();
        } else if (e.code === "Enter") {
            if (this.focusedOptionIndex > -1 && this.focusedOptionIndex < this.optionEls.length) {
                this.selectOption(this.focusedOptionIndex);
                this.focusedOptionIndex$.next(-1);
            }
        }
    }

    onArrowDown(e) {}

    onArrowUp(e) {}

    onEnter(e) {}

    onEscape(e) {}

    public setFocus() {
        this.buttonEl.focus();
    }
}

export { DropdownComponent };
